import Select from 'select-custom';

const DOM = {};

const cacheDOM = () => {
    DOM.select = document.querySelector('.filters__select');
};

const createSelect = (select) => {
    const customSelect = new Select(select, {
        optionBuilder: undefined,
        panelItem: { position: '', item: '', className: '' },
        changeOpenerText: true,
        multipleSelectionOnSingleClick: true,
        multipleSelectOpenerText: { labels: false, array: false },
        allowPanelClick: false,
        openOnHover: false,
        closeOnMouseleave: false,
        wrapDataAttributes: false,
        openerLabel: false,
    });

    customSelect.init();
};

const handleChange = (e) => {
    let url;
    const valor = e.target.value;
    const selectOptions = e.target.children;

    selectOptions.forEach((option) => {
        if (option.value === valor) {
            url = option.dataset.url;
        }
    });

    window.location.href = url;
};

const bindEvents = () => {
    DOM.select.addEventListener('change', handleChange);
};

const init = () => {
    cacheDOM();
    if (DOM.select) {
        createSelect(DOM.select);
        bindEvents();
    }
};

const filters = { init, createSelect };
export default filters;
